<template>
  <div>
    <div class="base-item">
        <div class="title">{{ $t('crm_partner_verified_detail_base.ji_chu_xin_xi') }}</div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('crm_partner_verified_detail_base.gong_si_ming_cheng') }}</div>
            <div class="val">{{ data.partnerName }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="key">{{ $t('crm_partner_verified_detail_base.tyshxydmyyzzbh') }}</div>
            <div class="val">{{ data.businessLicense }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('crm_partner_verified_detail_base.nsrsbhswdjbh') }}</div>
            <div class="val">{{ data.buyerNumber }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('crm_partner_verified_detail_base.fa_ren_xing_ming') }}</div>
            <div class="val">{{ data.legalPerson }}</div>
          </div>
          <div class="col">
            <div class="key">{{ $t('crm_partner_verified_detail_base.frsfzh') }}</div>
            <div class="val">{{ data.legalPersonIdentity }}</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },

  },
  data() {
    return {
      // 营业执照图片
      visible: false,
      // 证件照
      visible2: false,
      tableCode: 'company_admin_info',
      tableList: [],
    };
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>
